import { Store } from './Store.js';
import { ElementBuilder as E } from '../utils/ElementBuilder.js';

export class PageBuilder {
    constructor() {
        this.store = new Store();
        this.components = new Map();
    }

    async buildPageFromJson(pageName) {
        try {
            const pageContent = E.create('div', {
                className: 'page-content'
            });

            switch (pageName) {
                case 'dashboard':
                    await this.buildDashboard(pageContent);
                    break;
                case 'users':
                    await this.buildUsersPage(pageContent);
                    break;
                case 'settings':
                    await this.buildSettingsPage(pageContent);
                    break;
                default:
                    return this.buildErrorPage();
            }

            return pageContent;
        } catch (error) {
            console.error('Sayfa oluşturma hatası:', error);
            return this.buildErrorPage();
        }
    }

    async buildDashboard(container) {
        // Header bölümü
        const header = E.create('div', {
            className: 'dashboard-header',
            children: [
                E.create('h1', { text: 'Dashboard' }),
                E.create('p', { text: 'Hoş geldiniz!' })
            ]
        });

        // İstatistik kartları
        const statsContainer = E.create('div', {
            className: 'stats-container'
        });

        const statsConfigs = [
            {
                title: 'Toplam Kullanıcı',
                value: '1,234',
                icon: { name: 'users', color: 'primary' }
            },
            {
                title: 'Aktif Oturum',
                value: '56',
                icon: { name: 'user-check', color: 'success' }
            },
            {
                title: 'Toplam Satış',
                value: '₺45,678',
                icon: { name: 'shopping-cart', color: 'info' }
            }
        ];

        statsConfigs.forEach(config => {
            const card = E.create('div', {
                className: 'opt-stats-card',
                children: [
                    E.create('div', {
                        className: 'opt-stats-card-icon',
                        children: [
                            E.createIcon(config.icon.name, {
                                style: { color: `var(--${config.icon.color})` }
                            })
                        ]
                    }),
                    E.create('div', {
                        className: 'opt-stats-card-content',
                        children: [
                            E.create('h3', {
                                className: 'opt-stats-card-title',
                                text: config.title
                            }),
                            E.create('div', {
                                className: 'opt-stats-card-value',
                                text: config.value
                            })
                        ]
                    })
                ]
            });
            statsContainer.appendChild(card);
        });

        // Ana konteynere ekle
        container.appendChild(header);
        container.appendChild(statsContainer);
    }

    buildErrorPage() {
        return E.create('div', {
            className: 'error-page',
            children: [
                E.create('h1', { text: 'Hata' }),
                E.create('p', { text: 'Bir hata oluştu. Lütfen tekrar deneyin.' }),
                E.create('button', {
                    className: 'btn-primary',
                    text: 'Ana Sayfaya Dön',
                    onclick: () => window.location.href = '/'
                })
            ]
        });
    }
}